var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 89,
    viewBox: "0 0 83 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.8739 34.0998L18.2965 1.61573C16.4162 0.541165 14.2848 -0.0161912 12.1191 0.000358086C9.95346 0.0169074 7.83082 0.606773 5.96713 1.70995C4.15142 2.7484 2.64293 4.24893 1.59488 6.05911C0.546834 7.86929 -0.00342054 9.92462 1.59986e-05 12.0163V76.9845C-0.00342054 79.0762 0.546834 81.1315 1.59488 82.9417C2.64293 84.7519 4.15142 86.2524 5.96713 87.2909C7.831 88.3935 9.95358 88.9831 12.1191 88.9996C14.2847 89.0162 16.416 88.4591 18.2965 87.3851L75.8739 54.901C77.7309 53.8723 79.2785 52.3653 80.3562 50.5363C81.4339 48.7074 82.0022 46.6232 82.0022 44.5004C82.0022 42.3776 81.4339 40.2935 80.3562 38.4645C79.2785 36.6356 77.7309 35.1285 75.8739 34.0998V34.0998Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.9b7a582bf423b1fd2a2e335a2180c2fb.svg";
export { ForwardRef as ReactComponent };